module.exports = __webpack_public_path__ + "07d03dddb0bcc52c96fe64612651bdc9.svg";